import {
  Box,
  HStack,
  KdsCardFile,
  KdsEmptyContent,
  KdsText,
  theme,
  VStack,
} from "@kazaar-platform/design-system";
import { RiCheckboxCircleFill } from "@remixicon/react";
import { useTranslate } from "@tolgee/react";
import { OrderItemDetailsReadDtoDeliveryLabelStatusEnum } from "@/config/apiClient";
import { FeatureEnum } from "@/config/apiClient.types";
import { useGetIsFeatureActive } from "@/hooks";
import { useFile } from "@/hooks/queries/useFile";
import { type DeliveryLabelBlocProps } from "./DeliveryLabelBloc.types";

export const DeliveryLabelBloc = ({ orderItem }: DeliveryLabelBlocProps) => {
  const { t } = useTranslate();

  const { useDownloadFileHandler } = useFile();
  const { handleDownloadFile } = useDownloadFileHandler();

  const { isActive: isDeliveryLabelActive } = useGetIsFeatureActive(
    FeatureEnum.DELIVERY_LABEL
  );

  if (!isDeliveryLabelActive) {
    return null;
  }

  return (
    <Box bgColor="elevation.first" p="sp-md" rounded="br-sm">
      <VStack gap="sp-md">
        <HStack align="center" gap="sp-xs">
          <KdsText size="title-sm">
            {t("order.myOrdersItemDetails.deliveryLabel")}
          </KdsText>

          {orderItem?.deliveryLabelFile &&
            orderItem?.deliveryLabelStatus ===
              OrderItemDetailsReadDtoDeliveryLabelStatusEnum.LabelValidated && (
              <RiCheckboxCircleFill
                color={theme.colors.success.main}
                size={16}
              />
            )}
        </HStack>

        {orderItem?.deliveryLabelFile &&
        orderItem?.deliveryLabelStatus ===
          OrderItemDetailsReadDtoDeliveryLabelStatusEnum.LabelValidated ? (
          <KdsCardFile
            fileName={orderItem.deliveryLabelFile?.fileName}
            fileSize={orderItem.deliveryLabelFile?.size}
            fileUrl={orderItem.deliveryLabelFile?.url}
            isViewable
            isDownloadable
            onDownload={() =>
              handleDownloadFile(
                orderItem.deliveryLabelFile?.fileName,
                orderItem.deliveryLabelFile?.url
              )
            }
          />
        ) : (
          <KdsEmptyContent
            title={t("documentEmptyState.title")}
            description={t("documentEmptyState.subtitle")}
          />
        )}
      </VStack>
    </Box>
  );
};
